import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./terms.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";

export default class Terms extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }
    
    render() {
        return (
            <div>
                <div className="home">


                    <div class="position-relative overflow-hidden p-3 mb-5 mt-5 text-center bg-light">
                        <div class="col-md-5 mx-auto my-5">
                            <h1 class="display-4 font-weight-normal">Terms and Conditions </h1>
                            <p class="lead font-weight-normal">&nbsp;</p>
                        </div>
                        <div class="product-device shadow-sm d-none d-md-block"></div>
                        <div class="product-device product-device-2 shadow-sm d-none d-md-block"></div>
                    </div>

                    <div class="container mb-5 terms-conditions">
                        <h4 class="mt-4">Acceptance of Terms</h4>
                        <p class="lead text-justify">
                            Thank you for choosing us! By using our app, you agree to follow these Terms of Use, which are designed to ensure a safe and enjoyable experience for all users. If you have any concerns or do not agree with these terms, we kindly ask that you refrain from using the app.
                        </p>

                        <h4 class="mt-4">User Eligibility</h4>
                        <p class="lead text-justify">
                            You must be at least 13 years old to use the App. If you are under 18, you must have parental or legal guardian consent
                        </p>

                        <h4 class="mt-4">User Responsibilities</h4>
                        <ul>
                            <li>You must use the App in compliance with applicable laws, Google Play Store, and Apple App Store guidelines.</li>
                            <li>Do not attempt to hack, disrupt, or misuse the App.</li>
                            <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
                            <li>Users must not use the App for fraudulent, misleading, or illegal purposes.</li>
                        </ul>

                        <h4 class="mt-4">Prohibited Activities Users must not</h4>
                        <ul>
                            <li>Post or share illegal, abusive, or harmful content.</li>
                            <li>Engage in fraudulent or deceptive practices.</li>
                            <li>Attempt to access restricted areas of the App without authorization.</li>
                            <li>Use the App to collect, track, or store personal data of other users without their consent.</li>
                        </ul>

                        <h4 class="mt-4">Intellectual Property</h4>
                        <p class="lead text-justify">
                            All content within the App, including logos, text, and software, is owned by Ambrum Solutions and protected by intellectual property laws. Unauthorized use is prohibited.
                        </p>

                        <h4 class="mt-4">User-Generated Content</h4>
                        <ul>
                            <li>By submitting content through the App, you grant us a non-exclusive, worldwide license to use, modify, and display it as necessary to provide and improve our services. However, you retain ownership of your content, and we will always respect your rights and privacy.</li>
                            <li>We reserve the right to remove any content violating these Terms.</li>
                            <li>Content that infringes copyrights, trademarks, or intellectual property rights is prohibited.</li>
                        </ul>

                        <h4 class="mt-4">Privacy and Data Collection</h4>
                        <p class="lead text-justify">
                            Your use of the App is subject to our <a href="">Privacy Policy</a>, which outlines how we collect, use, and protect your data. We comply with GDPR, CCPA, Google Play Store, and Apple App Store privacy regulations.
                        </p>

                        <h4 class="mt-4">In-App Purchases and Subscriptions</h4>
                        <ul>
                            <li>Certain features of the App may require payments or subscriptions.</li>
                            <li>Payments are processed securely through Google Play Store and Apple App Store.</li>
                            <li>Subscriptions automatically renew unless canceled before the renewal date.</li>
                            <li>No refunds are provided unless required by applicable laws.</li>
                        </ul>

                        <h4 class="mt-4">Termination and Suspension</h4>
                        <p class="lead text-justify">
                            We may suspend or terminate your account if you violate these Terms. We reserve the right to remove access at our discretion.
                        </p>

                        <h4 class="mt-4">Disclaimer of Warranties</h4>
                        <p class="lead text-justify">
                            The App is provided "as is" without any warranties. We do not guarantee uninterrupted service or that the App will be error-free.
                        </p>

                        <h4 class="mt-4">Limitation of Liability</h4>
                        <p class="lead text-justify">
                            To the maximum extent permitted by law, we are not liable for any direct, indirect, or incidental damages arising from the use of the App.
                        </p>

                        <h4 class="mt-4">Changes to Terms</h4>
                        <p class="lead text-justify">
                            We may update these Terms at any time. Continued use of the App after changes means you accept the revised Terms.
                        </p>

                        <h4 class="mt-4">Contact Information</h4>
                        <p class="lead text-justify">
                            For any questions regarding these Terms, contact us at <a href="mailto:privacy@ambrumsolutions.com">privacy@ambrumsolutions.com</a>.
                        </p>

                    </div>
                    <ContactUsFooter />
                </div>
                <Footer />
            </div>

        );
    }
}
